import { useGenUiConfig } from '../../shared/ui/config.js';
import type { FlightAirportHistoryPort } from '@voll-intelligence/genui-contract';

// `config.tsx` importa o TIPO daqui via `airport_history_view` (puro); este arquivo
// expõe só o hook (React), igual ao par `flight_planner/airport_view.ts` + `port.ts`.

/** Lê o port `flightAirportHistory` do Context. `null` quando o host não o injeta —
 *  o campo DE/PARA então segue só com a busca remota por texto. */
export function useFlightAirportHistoryPort(): FlightAirportHistoryPort | null {
  return useGenUiConfig().ports?.flightAirportHistory ?? null;
}
